<!-- Hero Section -->
<section class="platform-hero">
  <div class="w-10/12 sm:w-9/12 mx-auto pt-16 pb-12 lg:pt-24 lg:pb-16">
    <div class="max-w-3xl mx-auto text-center">
      <h1 class="mb-6">
        {{ "platform_page.title" | translate }}
      </h1>
      <p class="text-lg leading-relaxed max-w-2xl mx-auto">
        {{ "platform_page.subtitle" | translate }}
      </p>
    </div>

    <!-- Pipeline Visualization -->
    <div class="mt-10 max-w-2xl mx-auto">
      <div class="pygPipelineCard">
        <div class="pygPipelineFlow">
          @for (step of pipelineSteps; track step.icon; let i = $index; let last = $last) {
            <div class="pygPipelineNode">
              <div class="pygPipelineNodeCircle" [style.animation-delay]="(i * 0.4) + 's'">
                <ng-icon [name]="step.icon" style="font-size: 1.25rem"></ng-icon>
              </div>
              <span class="pygPipelineNodeLabel">{{ step.labelKey | translate }}</span>
            </div>
            @if (!last) {
              <div class="pygPipelineLine" [style.animation-delay]="(i * 0.8 + 0.3) + 's'"></div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Pipeline Steps Section -->
<section class="pt-8 pb-10 lg:pt-10 lg:pb-14">
  <div class="w-10/12 sm:w-9/12 mx-auto">
    <div class="pipeline-steps-container">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <!-- Step 1: Collect -->
        <div class="pipeline-card">
          <div class="flex items-start gap-4">
            <div class="step-icon-wrapper shrink-0">
              <div class="step-badge">01</div>
              <div class="step-icon-circle">
                <ng-icon name="iconoirAntenna" style="font-size: 1.75rem"></ng-icon>
              </div>
            </div>
            <div class="flex-1">
              <h5 class="step-label">
                {{ "platform_page.collect_subtitle" | translate }}
              </h5>
              <h3 class="mb-2">
                {{ "platform_page.collect_title" | translate }}
              </h3>
              <p class="text-sm leading-relaxed">
                {{ "platform_page.collect_text" | translate }}
              </p>
            </div>
          </div>
        </div>

        <!-- Step 2: Process -->
        <div class="pipeline-card">
          <div class="flex items-start gap-4">
            <div class="step-icon-wrapper shrink-0">
              <div class="step-badge">02</div>
              <div class="step-icon-circle">
                <ng-icon name="iconoirCpu" style="font-size: 1.75rem"></ng-icon>
              </div>
            </div>
            <div class="flex-1">
              <h5 class="step-label">
                {{ "platform_page.process_subtitle" | translate }}
              </h5>
              <h3 class="mb-2">
                {{ "platform_page.process_title" | translate }}
              </h3>
              <p class="text-sm leading-relaxed">
                {{ "platform_page.process_text" | translate }}
              </p>
            </div>
          </div>
        </div>

        <!-- Step 3: Deliver -->
        <div class="pipeline-card">
          <div class="flex items-start gap-4">
            <div class="step-icon-wrapper shrink-0">
              <div class="step-badge">03</div>
              <div class="step-icon-circle">
                <ng-icon name="iconoirDashboardDots" style="font-size: 1.75rem"></ng-icon>
              </div>
            </div>
            <div class="flex-1">
              <h5 class="step-label">
                {{ "platform_page.deliver_subtitle" | translate }}
              </h5>
              <h3 class="mb-2">
                {{ "platform_page.deliver_title" | translate }}
              </h3>
              <p class="text-sm leading-relaxed">
                {{ "platform_page.deliver_text" | translate }}
              </p>
            </div>
          </div>
        </div>

        <!-- Step 4: Scale -->
        <div class="pipeline-card">
          <div class="flex items-start gap-4">
            <div class="step-icon-wrapper shrink-0">
              <div class="step-badge">04</div>
              <div class="step-icon-circle">
                <ng-icon name="iconoirGraphUp" style="font-size: 1.75rem"></ng-icon>
              </div>
            </div>
            <div class="flex-1">
              <h5 class="step-label">
                {{ "platform_page.scale_subtitle" | translate }}
              </h5>
              <h3 class="mb-2">
                {{ "platform_page.scale_title" | translate }}
              </h3>
              <p class="text-sm leading-relaxed">
                {{ "platform_page.scale_text" | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Security & Compliance Section -->
<section class="security-section py-12 lg:py-16">
  <div class="w-10/12 sm:w-9/12 mx-auto">
    <div class="security-card">
      <div class="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
        <div class="shrink-0">
          <div class="security-icon-circle">
            <ng-icon name="iconoirShieldCheck" style="font-size: 5rem"></ng-icon>
          </div>
        </div>
        <div class="flex-1">
          <h2 class="mb-4">
            {{ "platform_page.security_title" | translate }}
          </h2>
          <p class="text-base leading-relaxed max-w-2xl">
            {{ "platform_page.security_text" | translate }}
          </p>
          <div class="compliance-badges mt-8 flex flex-wrap gap-4">
            <span class="compliance-badge">GDPR</span>
            <span class="compliance-badge">ISO 27001</span>
            <span class="compliance-badge">SOC 2</span>
            <span class="compliance-badge">End-to-End Encryption</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="cta-section py-12 lg:py-16">
  <div class="w-10/12 sm:w-9/12 mx-auto text-center">
    <h2 class="cta-heading mb-6">
      {{ "platform_page.cta_title" | translate }}
    </h2>
    <div class="flex justify-center mt-8">
      <app-get-demo></app-get-demo>
    </div>
  </div>
</section>
